import React from 'react';
import { Box, Typography } from '@mui/material';

// first={true} → sin borde ni margen superior (primera sección del form)
export default function FormSection({ title, children, first = false, sx = {} }) {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      mt: first ? 0 : '16px',
      pt: first ? 0 : '20px',
      borderTop: first ? 'none' : '1px solid rgba(144,202,249,0.12)',
      ...sx,
    }}>
      {title && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: '2px' }}>
          <Typography sx={{
            fontSize: 10,
            fontWeight: 700,
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: 1.2,
            lineHeight: 1,
            whiteSpace: 'nowrap',
          }}>
            {title}
          </Typography>
          <Box sx={{ flex: 1, height: '1px', bgcolor: 'rgba(144,202,249,0.1)' }} />
        </Box>
      )}
      {children}
    </Box>
  );
}
